<template>
    <div v-loading="loading">
        <table class="table" v-if="!isEmpty(model)">
            <tr class="table__row">
                <td class="table__data">
                    <h2 class="order-number__headline">
                        {{ model.order_number }}
                    </h2>
                </td>
                <td class="table__data" colspan="2">
                    <strong>Delivery to</strong><br />
                    <span v-if="model.company">{{ model.company }}</span
                    ><br />
                    <span>
                        {{ model.ship_address.firstname }}
                        {{ model.ship_address.lastname }}</span
                    >
                    <span>{{ model.ship_address.address1 }}</span
                    ><br />
                    <span v-if="model.ship_address.address2">
                        {{ model.ship_address.address2 }}
                    </span>
                    <span
                        >{{ model.ship_address.city }},
                        {{ model.ship_address.zip }} </span
                    ><br />
                    <span>{{ model.ship_address.country }}</span
                    ><br />
                    <span>{{ model.email }}</span
                    ><br />
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data">
                    <strong>Order Date</strong><br />
                    {{ model.ordered_on | datetime }}
                </td>
                <td class="table__data">
                    <strong>Payment Method</strong><br />
                    {{ model.payments[0].payment_type }} ({{
                        model.payments[0].created_at | datetime
                    }})
                </td>
                <td class="table__data">
                    <strong>Delivery Details</strong><br />
                    {{ model.shipping_method_name }}
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data" colspan="3">
                    <strong>Customer Note</strong><br />
                    <ul>
                        <li
                            v-for="(note, key) in model.shipping_notes"
                            :key="key"
                        >
                            <strong>{{ formatNoteObjectKey(key) }}:</strong>
                            {{ note }}
                        </li>
                    </ul>
                </td>
            </tr>
        </table>

        <table class="table" v-if="!isEmpty(model)">
            <tr class="table__row">
                <td class="table__data"><strong>Name</strong></td>
                <td class="table__data"><strong>Price</strong></td>
                <td class="table__data"><strong>Amount</strong></td>
                <td class="table__data"><strong>Total</strong></td>
            </tr>
            <tr
                class="table__row"
                v-for="product in model.order_items"
                :key="product.id"
            >
                <td class="table__data">
                    {{ product.meta_data.name }}<br />
                    SKU: {{ product.meta_data.sku }}
                </td>
                <td class="table__data">
                    {{ product.value | currency(model.currency) }}
                </td>
                <td class="table__data">
                    {{ product.quantity }}
                </td>
                <td class="table__data">
                    <div
                        v-if="
                            product.meta_data &&
                            product.meta_data.properties &&
                            isDynamicPricePackage(product.meta_data.properties)
                        "
                    >
                        <div v-if="product.total_value && product.discount">
                            {{
                                (product.total_value -
                                    Math.abs(product.discount))
                                    | currency(model.currency + ' ')
                            }}
                        </div>
                        <div v-if="product.total_value" class="text-zinc-400">
                            <del>{{
                                product.total_value
                                    | currency(model.currency + ' ')
                            }}</del>
                        </div>
                        <div v-if="product.discount">
                            <strong>Your savings:</strong><br />{{
                                Math.abs(product.discount)
                                    | currency(model.currency + ' ')
                            }}
                        </div>
                    </div>
                    <div v-else-if="product.total_value">
                        {{
                            product.total_value | currency(model.currency + ' ')
                        }}
                    </div>
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data" colspan="3">
                    <strong>Coupon discount</strong>
                </td>
                <td class="table__data" colspan="3">
                    {{ model.coupon_discount | currency(model.currency) }}
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data" colspan="3">
                    <strong>Subtotal</strong>
                </td>
                <td class="table__data" colspan="3">
                    {{ model.subtotal | currency(model.currency) }}
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data" colspan="3">
                    <strong>Versand</strong>
                </td>
                <td class="table__data" colspan="3">
                    {{ model.shipping | currency(model.currency) }}
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data" colspan="3">
                    <strong>Tax</strong>
                </td>
                <td class="table__data" colspan="3">
                    {{ model.tax | currency(model.currency) }}
                </td>
            </tr>
            <tr class="table__row">
                <td class="table__data" colspan="3">
                    <strong>Total</strong>
                </td>
                <td class="table__data" colspan="3">
                    <strong>{{
                        model.total | currency(model.currency)
                    }}</strong>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import api from '../libs/api';

export default {
    name: 'v-crud-print',

    props: ['config', 'rootConfig', 'params', 'id'],

    data() {
        return {
            model: {},
            loading: false,
        };
    },

    mounted() {
        this.loadData();
    },

    watch: {
        '$route.params.model'() {
            this.loadData();
        },
    },

    methods: {
        loadData() {
            this.loading = true;
            api.res
                .get({ id: this.id })
                .then(this.setModelData)
                .catch(api.errorHandler);
        },
        setModelData(res) {
            if (this.config.singleRootObject) {
                this.model = res.body[this.config.singleRootObject];
            } else {
                if (res.body.hasOwnProperty('attachments')) {
                    res.body.attachments = res.body.attachments.join('\n');
                }
                this.model = res.body;
            }
            this.loading = false;
            this.activeTab = '0';

            setTimeout(() => {
                window.print();
            }, 1000);
        },
        formatNoteObjectKey(key) {
            return key.replaceAll('_', ' ');
        },
        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        },
        isDynamicPricePackage(properties) {
            return (
                properties.filter(
                    (property) => property.slug === 'dynamicPricePackage'
                ).length > 0
            );
        },
    },
};
</script>

<style>
.table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    margin-bottom: 20px;
}

.table__row:nth-of-type(odd) {
    background: #f8f8f8;
}

.table__data {
    border: 1px solid #d4d3d1;
    padding: 12px 12px;
}

.order-number__headline {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// VueCrudPrint.vue?88ffc02a